import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AssignCourseModal from "../../components/modal/AssignCourseModal";
import { loginBrokerResponse } from "../../redux/auth/actions";
import { getBrandTheme, setUserRole, userDetailBroker } from "../../redux/user/actions";
import { applyTheme, clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import $ from "jquery";
import MyCertificates from "../../components/menu_detail/MyCertificates";
import MyBadges from "../../components/menu_detail/MyBadges";
import _ from "lodash";


const CertificateAndBadgeMobile = () => {

    const dispatch = useDispatch()

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const key = params.get('key');
    const username = params.get('username');
    const user_id = params.get('user_id');
    const color_1 = params.get('color_1');
    const color_2 = params.get('color_2');
    const role = params.get('role');

    const isOther = params.get('isOther');
    const apply_theme = params.get('apply_theme');


    const brandThemeRes = useSelector((state) => state.user.brandThemeRes);




    const [isLoading, setIsLoading] = useState(true)
    const [isValidKey, setIsValidKey] = useState(false)

    useEffect(() => {
        console.log('key', params.get('key'))
        if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
            $('html').css("--color-element-1", color_1 ? '#' + color_1 : CONFIG.COLOR_ELEMENT_1);
            $('html').css("--color-element-2", color_2 ? '#' + color_2 : CONFIG.COLOR_ELEMENT_2);
            // applyTheme({
            //     "primary_btn_color": "#008c9a",
            //     "secondary_btn_color": "#232a34",
            //     "icon_color": "#008c9a",
            //     "currwk_header_color": "#00b70e",
            //     "ptwk_header_color": "#B1B1B1",
            //     "ftwk_header_color": "#232a34",
            //     "footer_bg_color": "#ffffff",
            //     "footer_text_color": "#bebcbc",
            //     "course_launch_url": "https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/branding/398/course-launch-img/course_launch_url_img.png"
            // })
            localStorage.setItem(SessionKeys.API_TOKEN_BROKER, token);
            localStorage.setItem(SessionKeys.USERNAME, username);
            setIsValidKey(true)
            dispatch(setUserRole(role))
            dispatch(loginBrokerResponse({
                payload: {
                    user: {
                        user_id: user_id,
                        username: username,
                        role: [role]
                    },
                    apiToken: token
                }
            }))

            dispatch(
                userDetailBroker({
                    module: "getOrderDetailBroker",
                    apiToken: token,
                })
            );
            clickStreamUser('roleplay_mobile_page', {
                userId: user_id,
            })

            if (apply_theme === "true") {
                dispatch(getBrandTheme({
                    module: "getBrandTheme",
                    postData: {
                        token: token
                    }
                }))
            }
        }
    }, [token, key, user_id, dispatch])

    useEffect(() => {
        console.log('brandThemeRes: ', brandThemeRes)
        if (!_.isEmpty(brandThemeRes)) {
            if (brandThemeRes?.status === "success") {
                const branding = brandThemeRes.payload.payload.branding;
                !_.isEmpty(branding) && applyTheme(branding)

            }
        }
    }, [brandThemeRes])

    useEffect(() => {
        window.scrollTo(0, 0)
        if (document.getElementById("id_page_404") !== null) {
            document.getElementById("id_page_404").style.display = "none";
        }
        setTimeout(() => {
            if (document.getElementById("cc_div") !== null)
                document.getElementById("cc_div").style.display = "none";
        }, 100)
    }, [])

    return (
        <>
            {isValidKey ?
                <>
                    <MyCertificates setIsLoading={setIsLoading} />

                    {/* <div className="center_line m-0"></div> */}

                    {/* <MyBadges isOther={isOther} /> */}
                </>
                :
                <div>
                    Invalid Key
                </div>
            }
        </>
    )



}

export default CertificateAndBadgeMobile;